export default __webpack_public_path__ + "static/media/keto_sleep@3x.5e7d0132.jpg";